import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Col, Dropdown, DropdownItem, DropdownMenu, Input, Row, Table } from "reactstrap";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, constants, dateHelpers, helpers, UserContext } from "../../utils";
import { DesktopContainer } from "../../layouts";
import { useGetItemClasses, useGetMachineSetupNames, useGetPrinters } from "../../hooks";
import { usePreviousHook } from "../../components/SpecEditComponents/index";
import { ItemDropdownMenu } from "..";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import ServiceThreadSpinner from "../ServiceThreadSpinner";
import classNames from "classnames";
import { LabelSwitch } from "../";
const cancelToken = axios.CancelToken;
const source = cancelToken.source();

export default function ProductionPlanning(props) {
   const { currentUser } = useContext(UserContext);
   const navigate = useNavigate();
   const firstRender = useRef(true);
   const { ClassList, Success } = useGetItemClasses({ IsPurchasedMaterial: null, });
   const { MachineSetupList, OrderRangeList, MachineSetupSuccess } = useGetMachineSetupNames();
   const { PrinterList, PrinterSuccess } = useGetPrinters();
   const [casesToSend, setCasesToSend] = useState([]);
   const [form, setForm] = useState({
      payload: {
         itemClassSelect: [],
         orderRangeSelect: null,
         machineSetupSelect: null,
         exclude: true,
      },
   });
   const [loading, setLoading] = useState(false);
   const [printer, setPrinter] = useState(null);
   const [printToPrinter, setPrintToPrinter] = useState(true);
   const [productionPlanningList, setProductionPlanningList] = useState({
      production: [],
      sample: [],
   });
   const [working, setWorking] = useState(false);
   const plan = usePreviousHook(form.payload);

   useEffect(() => {
      document.title = `Production Planning`;
      if (!firstRender.current) {
         if (
            _.isNil(form.payload.itemClassSelect) &&
            _.isNil(form.payload.machineSetupSelect) &&
            _.isNil(form.payload.orderRangeSelect)
         ) {
            toast.warning("please select some criteria to view production info or print reports");
            return;
         }
         if (_.isNil(form.payload.orderRangeSelect)) {
            toast.warning("order range is a required field");
            return;
         }
         if (_.isEqual(plan, form.payload)) return;
         showProdPlan();
      } else {
         firstRender.current = false;
      }

      // return () => {
      //   source.cancel("axios request cancelled");
      // };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [form]);

   useEffect(() => {
      if (OrderRangeList && OrderRangeList.length && !form.payload.orderRangeSelect) {
         let currentWeek = _.find(OrderRangeList, (or) =>
            or?.label.includes(constants.MACHINE_SETUP_ORDER_RANGE_LABELS.CURRENT_WEEK)
         );
         if (currentWeek) {
            onChange("payload.orderRangeSelect", currentWeek);
         }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [OrderRangeList]);

   function ColPrompt({ title }) {
      return (
         <Col xs="3" className="text-white pt-2">
            <h5 style={{ textAlign: "right" }}>{title}:</h5>
         </Col>
      );
   }

   const createPayload = () => {
      let copy = _.cloneDeep(form.payload);
      let payload = {};
      for (let key in copy) {
         let value = copy[key];
         if (_.includes(key, "Selec")) {
            let newKey = key.slice(0, key.length - 6);
            let newValue = value;
            newValue = helpers.valueFromSelect(value);
            newValue = _.trim(newValue);
            Object.assign(payload, { [newKey]: newValue });
         } else {
            Object.assign(payload, { [key]: value });
         }
      }
      payload.itemClass = helpers.getCommaDelimitedString(copy.itemClassSelect);
      payload.machineSetup = parseInt(payload.machineSetup)
         ? payload.machineSetup
         : null;
      payload.orderRange = parseInt(payload.orderRange) ? payload.orderRange : 0;
      //console.log(payload);
      return payload;
   };

   const createWorkOrders = () => {
      if (_.isEmpty(casesToSend) || _.isNil(printer)) {
         if (_.isNil(printer)) {
            toast.info("please choose a valid printer");
            return;
         }
         toast.info("please provide a valid number to create work orders");
         return;
      }
      let cases = _.map(casesToSend, (x) => {
         return { Item1: x.value[0], Item2: parseInt(x.value[1]) };
      });
      const payload = {
         casesToBuild: cases,
         printerName: printer.label,
         printToPrinter: printToPrinter,
         printerId: printer.value,
      };
      setWorking(true);
      api
         .postDownloadBinary(
            `Production/CreateWorkOrders`,
            payload,
            constants.MIME_TYPES.pdf,
            `ProductionPlanning_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
            "There was an error downloading the labels and reports for production planning pdf."
         )
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            } else {
               showProdPlan();
               setCasesToSend([]);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
         })
         .finally(() => setWorking(false));
   };

   const downloadXLSX = () => {
      let payload = createPayload();
      setWorking(true);
      toast.info("Generating report. This can take a few minutes. Please be patient.");
      api
         .postGetBlob("Report/ProductionPlanningXLSX", payload)
         .then((r) => {
            if (r.data) {
               const fileName = `ProductionPlanning_${dateHelpers.toMDYDateString(Date.now())}.xlsx`;
               helpers.downloadExport(r.data, fileName, constants.MIME_TYPES.xlsx);
            } else {
               toast.error(r.message || "Something went wrong generating the report");
            }
         })
         .catch(api.catchHandler)
         .finally(() => {
            setWorking(false);
         });
   };

   const onChange = (property, value) => {
      let copy = _.cloneDeep(form);
      _.set(copy, property, value);
      setForm(copy);
   };

   const onChangeCases = (index, itemNum, cases) => {
      let entireCopy = _.cloneDeep(casesToSend);
      if (cases === null || cases === 0 || (cases === "0" && _.isEmpty(entireCopy)))
         return;

      let casesToBuild = _.map(entireCopy, (x) => x.idx);
      if (_.includes(casesToBuild, index)) {
         // if cases is false then remove from the list
         if (!cases || cases === "0") {
            let filteredCopy = _.filter(entireCopy, (x) => x.idx !== index);
            setCasesToSend(filteredCopy);
            return;
         } else {
            // change the number if needed
            let changedCopy = _.filter(entireCopy, (x) => {
               if (x.idx === index) {
                  x.value = [itemNum, cases];
               }
               return x;
            });
            setCasesToSend(changedCopy);
            return;
         }
      } else {
         // add if cases is truthy
         if (cases) {
            entireCopy.push({ idx: index, value: [itemNum, cases] });
            setCasesToSend(entireCopy);
         }
      }
   };

   const runMSRPlanReport = () => {
      let payload = createPayload();
      setWorking(true);
      api
         .postDownloadBinary(
            `Report/RunProductionPlanningMSR`,
            payload,
            constants.MIME_TYPES.pdf,
            `Production_Planning_MSR_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
            "There was an error downloading the Production Planning MSR pdf."
         )
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
         })
         .finally(() => setWorking(false));
   };

   const runPlanReport = () => {
      let payload = createPayload();
      setWorking(true);
      api
         .postDownloadBinary(
            `Report/RunProductionPlanning`,
            payload,
            constants.MIME_TYPES.pdf,
            `Production_Planning_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
            "There was an error downloading the Production Planning pdf."
         )
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
         })
         .finally(() => setWorking(false));
   };

   const showProdPlan = () => {
      let payload = createPayload();
      setLoading(true);
      const productionPlanning = api
         .postS(`Production/GetProductionPlanningInfo`, payload, source.token)
         .then((r) =>
            r?.data?.productionPlanning
               ? { productionList: r.data.productionPlanning }
               : { productionList: [] }
         )
         .catch(api.catchHandler);

      const productionPlanningSample = api
         .postS(`Production/SampleOrderGetByDateRange`, payload, source.token)
         .then((r) =>
            r?.data?.sampleOrders
               ? { sampleList: r.data.sampleOrders }
               : { sampleList: [] }
         )
         .catch(api.catchHandler);

      let apiCalls = [productionPlanning, productionPlanningSample];
      Promise.all(apiCalls)
         .then((array) => {
            let result = {};
            _.each(array, (x) => Object.assign(result, x));
            if (!_.isEmpty(result)) {
               const { productionList, sampleList } = result;
               setProductionPlanningList({
                  production: productionList,
                  sample: sampleList,
               });
            }
         })
         .catch((err) => {
            toast.error("an error has occurred while fetching production planning info, please contact an admin");
            api.catchHandler(err);
         })
         .finally(() => setLoading(false));
   };

   const valueFrom = (index) => {
      let entireCopy = _.cloneDeep(casesToSend);
      if (_.isEmpty(entireCopy)) {
         return "";
      } else {
         let casesToBuild = _.map(entireCopy, (x) => x.idx);
         if (_.includes(casesToBuild, index)) {
            let returnValue = _.find(entireCopy, (x) => x.idx === index);
            if (_.isNil(returnValue)) return "";
            return returnValue.value[1];
         }
         return "";
      }
   };

   const ready = Success && MachineSetupSuccess && PrinterSuccess;
   let alreadyDisplayed = [];
   return (
      <DesktopContainer screenName={"Production Planning"}>
         <ServiceThreadSpinner on={!ready}>
            <div className="filter-header mb-3">
               <Row className="marginTopAndBottom">
                  <ColPrompt title="Item Class" />
                  <Col xxl={6}>
                     <Select
                        classNamePrefix="serviceThreadSelect"
                        options={ClassList}
                        value={form.payload.itemClassSelect}
                        onChange={(e) =>
                           _.isNil(e)
                              ? setForm({
                                 ...form,
                                 payload: { ...form.payload, itemClassSelect: [] },
                              })
                              : setForm({
                                 ...form,
                                 payload: { ...form.payload, itemClassSelect: e },
                              })
                        }
                        isClearable={true}
                        isMulti={true}
                        isDisabled={loading}
                     />
                  </Col>
               </Row>
               <Row className="marginTopAndBottom">
                  <ColPrompt title="Order Range" />
                  <Col xxl={6}>
                     <Select
                        classNamePrefix="serviceThreadSelect"
                        options={OrderRangeList}
                        value={form.payload.orderRangeSelect}
                        onChange={(opt) => onChange("payload.orderRangeSelect", opt)}
                        isClearable={true}
                        isDisabled={loading}
                     />
                  </Col>
               </Row>
               <Row className="marginTopAndBottom">
                  <ColPrompt title="Machine Setup" />
                  <Col xxl={6}>
                     <Select
                        classNamePrefix="serviceThreadSelect"
                        options={MachineSetupList}
                        value={form.payload.machineSetupSelect}
                        onChange={(opt) => onChange("payload.machineSetupSelect", opt)}
                        isClearable={true}
                        isDisabled={loading}
                     />
                  </Col>
                  <Col className="text-white pt-2">Applies only to MSR report</Col>
               </Row>
               {currentUser?.isAdmin || currentUser?.isPowerUser ? (
                  <Row> {/* Normal users cannot see this check box */}
                     <Col xxl={{ offset: 3, size: 6 }} className="text-white ps-3" style={{ display: "flex" }}>
                        <Input
                           type="checkbox"
                           className="float-end me-3"
                           checked={form.payload.exclude}
                           disabled={loading}
                           onChange={() => onChange("payload.exclude", !form.payload.exclude)}
                        />
                        <span>
                           Exclude Items where the recommended quantity to build is 0
                        </span>
                     </Col>
                  </Row>
               ) : null}
               <Row>
                  <Col xxl={{ offset: 3, size: 6 }} className="marginTopAndBottom text-white" style={{ display: "flex" }}>
                     <Button
                        className="shredButton mx-3"
                        disabled={working}
                        onClick={() => runPlanReport()}
                     >
                        run planning report
                     </Button>
                     <Button
                        className="shredButton"
                        disabled={working}
                        onClick={() => runMSRPlanReport()}
                     >
                        run msr planning report
                     </Button>
                  </Col>
               </Row>
            </div>
            <ServiceThreadSpinner on={loading}>
               {_.isEmpty(productionPlanningList.production) && (
                  <>
                     <Row
                        className="mb-1 px-5"
                        children={<Col children={<h5>Open Orders: </h5>} />}
                     />
                     <div className="h5 text-center mt-2">No data was found for the criteria options selected</div>
                  </>
               )}

               {!_.isEmpty(productionPlanningList.production) && (
                  <>
                     <Row className="mb-1 px-5">
                        <Col
                           xxl={10}
                           className="pt-3"
                           children={
                              <span className="text-brightRed">
                                 Cases to build listed in red are in LBS and not cases. GP
                                 Does not have the expected case weight entered for that
                                 item, therefore the system cannot determine the correct
                                 number of cases to build.
                              </span>
                           }
                        />
                        <Col xxl={2}>
                           <Button
                              title="Download as .xlsx"
                              className="shredButtonExcel float-end me-3"
                              onClick={() => downloadXLSX()}
                           >
                              <FontAwesomeIcon icon="file-excel" size="lg" />
                           </Button>
                        </Col>
                     </Row>
                     <Row
                        className="mb-1 px-5"
                        children={
                           <Table size="sm" className="data-table">
                              <thead className="table-header">
                                 <tr>
                                    <th children={"Item"} />
                                    <th children={"Class"} />
                                    <th children={"Order #"} />
                                    <th children={"Customer"} />
                                    <th children={<span>Req<br />Ship Date</span>} />
                                    <th children={<span>Release<br />Qty</span>} />
                                    <th children={<span>BO<br />Qty</span>} />
                                    <th children={<span>App<br />Qty</span>} />
                                    <th children={"Available"} />
                                    <th children={<span>Order<br />Point</span>} />
                                    <th children={<span>Order<br />Totals</span>} />
                                    <th children={<span>Release<br />Totals</span>} />
                                    <th children={<span>BO<br />Totals</span>} />
                                    <th children={<span>Open WO<br />Labels</span>} />
                                    <th children={<span>Std<br />Wt</span>} />
                                    <th children={<span>WO Labels<br />To Print</span>} />
                                    <th children={<span>Quantity<br />To Build</span>} />
                                    <th children={""} />
                                 </tr>
                              </thead>
                              <tbody>
                                 {_.map(productionPlanningList.production, (x, index) => {
                                    const hide = _.includes(alreadyDisplayed, x.itemnmbr);
                                    alreadyDisplayed.push(x.itemnmbr);
                                    return (
                                       <tr
                                          key={index}
                                          className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
                                       >
                                          {hide ? (
                                             <td children={""} />
                                          ) : (
                                             <ItemDropdownMenu
                                                itemNumber={x.itemnmbr}
                                                itemDescription={x.itemWithDesc}
                                                attachmentCount={x.itemAttachmentCount}
                                             />
                                          )}
                                          {hide ? (
                                             <td children={""} />
                                          ) : (
                                             <td className="data-cell">{x.itmclscd}</td>
                                          )}
                                          <td className="data-cell">{x.sopnumbe}</td>
                                          <td
                                             className="data-cell boldedOrange"
                                             style={{ cursor: "pointer" }}
                                             onClick={() => navigate(constants.ENDPOINTS.customerDashboard, { state: { label: x.custname, value: x.custnmbr }, replace: true })}
                                          >
                                             {x.customerNameNumber}
                                          </td>
                                          <td className="data-cell">
                                             {"0001-01-01T00:00:00" === x.reqshipdate ? "" : dateHelpers.toLongDateString(x.reqshipdate)}
                                          </td>
                                          <td className="data-cell">
                                             {x.releaseQty.toLocaleString("en-US", { maximumFractionDigits: 0, })}
                                          </td>
                                          <td className="data-cell">
                                             {x.qtytbaor.toLocaleString("en-US", { maximumFractionDigits: 0, })}
                                          </td>
                                          <td className="data-cell">
                                             {x.applied.toLocaleString("en-US", { maximumFractionDigits: 0, })}
                                          </td>
                                          {hide ? (
                                             <td children={""} />
                                          ) : (
                                             <td className="data-cell">
                                                {x.available.toLocaleString("en-US", { maximumFractionDigits: 0, })}
                                             </td>
                                          )}
                                          {hide ? (
                                             <td children={""} />
                                          ) : (
                                             <td className="data-cell">
                                                {x.ordrpntqty.toLocaleString("en-US", { maximumFractionDigits: 0, })}
                                             </td>
                                          )}
                                          {hide ? (
                                             <td children={""} />
                                          ) : (
                                             <td className="data-cell">
                                                {x.onOrderTotal.toLocaleString("en-US", { maximumFractionDigits: 0, })}
                                             </td>
                                          )}
                                          {hide ? (
                                             <td children={""} />
                                          ) : (
                                             <td className="data-cell">
                                                {x.releaseTotal.toLocaleString("en-US", { maximumFractionDigits: 0, })}
                                             </td>
                                          )}
                                          {hide ? (
                                             <td children={""} />
                                          ) : (
                                             <td className="data-cell">
                                                {x.backOrderTotal.toLocaleString("en-US", { maximumFractionDigits: 0, })}
                                             </td>
                                          )}

                                          {hide ? (
                                             <td children={""} />
                                          ) : x.existingWorkOrders ? (
                                             <ProductionPlanningDropDown
                                                existingWorkOrders={x.existingWorkOrders}
                                                openWorkOrderCases={x.openWorkOrderCases}
                                             />
                                          ) : (
                                             <td children={""} />
                                          )}
                                          {hide ? (
                                             <td children={""} />
                                          ) : (
                                             <td
                                                className={classNames("data-cell", {
                                                   "text-brightRed": x.expectedCaseWeight === 0,
                                                })}
                                             >
                                                {x.expectedCaseWeight.toLocaleString("en-US", { maximumFractionDigits: 0, })}
                                             </td>
                                          )}
                                          {hide ? (
                                             <td children={""} />
                                          ) : (
                                             <td
                                                className={classNames("data-cell", {
                                                   "text-brightRed": x.expectedCaseWeight === 0,
                                                })}
                                             >
                                                {x.quantityToBuild.toLocaleString("en-US", { maximumFractionDigits: 0, })}
                                             </td>
                                          )}
                                          {hide ? (
                                             <td children={""} />
                                          ) : (
                                             <td className="data-cell">
                                                {x.quantityToBuildPounds.toLocaleString("en-US", { maximumFractionDigits: 0 } )}
                                             </td>
                                          )}
                                          {hide ? (
                                             <td children={""} />
                                          ) : (
                                             <td className="data-cell">
                                                <Input
                                                   type="number"
                                                   value={valueFrom(index)}
                                                   onChange={(e) =>
                                                      onChangeCases(index, x.itemnmbr, e.target.value)
                                                   }
                                                />
                                             </td>
                                          )}
                                       </tr>
                                    );
                                 })}
                              </tbody>
                           </Table>
                        }
                     />
                  </>
               )}


               {!_.isEmpty(productionPlanningList.sample) && (
                  <>
                     <br /><br /><br />
                     <Row
                        className="mb-1 px-5"
                        children={<Col children={<h5>Sample Orders: (criteria options are not applicable) </h5>} />}
                     />
                     <Row
                        className="mb-1 px-5"
                        children={
                           <Table size="sm" className="data-table">
                              <thead className="table-header">
                                 <tr>
                                    <th children={"Item #"} />
                                    <th children={"Item Description"} />
                                    <th children={"Order #"} />
                                    <th children={"Customer"} />
                                    <th children={<span>Req Ship Date</span>} />
                                    <th children={<span>Qty Ordered</span>} />
                                    <th children={<span>BO Qty</span>} />
                                    <th children={<span>App Qty</span>} />
                                    <th children={"Freight Carrier"} />
                                 </tr>
                              </thead>
                              <tbody>
                                 {_.map(productionPlanningList.sample, (x, index) => {
                                    // const hide = _.includes(alreadyDisplayed, x.itemnmbr);
                                    const hide = false;
                                    // alreadyDisplayed.push(x.itemnmbr);
                                    return (
                                       <tr
                                          key={index}
                                          className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
                                       >
                                          {hide ? (
                                             <td children={""} />
                                          ) : (
                                             <ItemDropdownMenu
                                                itemNumber={x.itemNumber}
                                                itemDescription={x.itemWithDesc}
                                             // attachmentCount={cmxp.itemAttachmentCount}
                                             />
                                          )}
                                          <td className="data-cell">{x.itemWithDesc}</td>
                                          <td className="data-cell">{x.orderId}</td>
                                          <td className="data-cell">{x.customerIdName}</td>
                                          <td className="data-cell">
                                             {dateHelpers.toLongDateString(x.requiredShipDate)}
                                          </td>
                                          <td className="data-cell">
                                             {x.qtyRemaining.toLocaleString("en-US", { maximumFractionDigits: 0, })}
                                          </td>
                                          <td className="data-cell">
                                             {x.qtyBackOrdered.toLocaleString("en-US", { maximumFractionDigits: 0, })}
                                          </td>
                                          <td className="data-cell">
                                             {x.qtyFullfilled.toLocaleString("en-US", { maximumFractionDigits: 0, })}
                                          </td>
                                          <td className="data-cell">{x.shipperNamePhone}</td>
                                       </tr>
                                    );
                                 })}
                              </tbody>
                           </Table>
                        }
                     />
                  </>
               )}
               <Row
                  className={classNames("px-5", {
                     "d-none": _.isEmpty(productionPlanningList.production),
                  })}
               >
                  <Col className="" xxl={2} style={{ display: "flex" }}>
                     <h5 className="pt-2">Zebra Label Printer:</h5>
                  </Col>
                  <Col className="" xxl={4}>
                     <Select
                        classNamePrefix="serviceThreadSelect"
                        options={PrinterList}
                        value={printer}
                        onChange={(e) => setPrinter(e)}
                        isClearable
                     />
                  </Col>
                  <Col>
                     <LabelSwitch
                        displayName="Print to Printer?"
                        buttonLabel="Create Work Orders"
                        onChangeCallback={(e) => setPrintToPrinter(e)}
                        onButtonClick={() => createWorkOrders()}
                        disabled={working}
                     />
                  </Col>
               </Row>
            </ServiceThreadSpinner>
         </ServiceThreadSpinner>
      </DesktopContainer>
   );
}

function ProductionPlanningDropDown({ existingWorkOrders, openWorkOrderCases }) {
   const [open, setOpen] = useState(false);

   return (
      <td
         className="data-cell"
         onMouseEnter={() => setOpen(true)}
         onMouseLeave={() => setOpen(false)}
         style={{ position: "relative" }}
      >
         <span className="shredLink fw-bold noWrap">{openWorkOrderCases}</span>

         <Dropdown
            isOpen={open}
            toggle={() => setOpen(!open)}
            style={{ position: "absolute", top: "2em", left: "3em" }}
         >
            <DropdownMenu flip>
               {_.map(existingWorkOrders, (x, index) => {
                  let txtEnd = x.openCaseCount > 1 ? "cases" : "case";
                  return (
                     <DropdownItem key={index} className="sort-handle">
                        <a rel="noreferrer"
                           href={`${constants.ENDPOINTS.workOrderDetail}/${x.workOrderId}`}
                           target="_blank"
                           className="regularAnchor"
                        >
                           {`${x.displayId} = ${x.openCaseCount} ${txtEnd}`}
                        </a>
                     </DropdownItem>
                  );
               })}
            </DropdownMenu>
         </Dropdown>
      </td>
   );
}
